import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { translate } from 'react-i18next';
import FlatButton from 'material-ui/FlatButton';
import swal from 'sweetalert';

var Config = require('../config');

class ModalSetInfoSession extends Component{
	constructor(props, context) {
		super(props, context);
		this.save = this.save.bind(this);
		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.state = {
		    show: false,
		    user_name:"",
		    health_facilities:[],
		    facility_sections:[],
		    health_facilities_id:"",
		    health_facilities_name:"",
		    facility_sections_id:"",
		    profile:"",
		    profiles:[],
		    require_convoke_place:false,
		    convoke_places:[],
		    convoke_places_id:"",
		    matriz:"",
		    entity_type:""
		};
	}

	componentDidMount() {
		this.props.onRef(this);
	}
	componentWillUnmount() {
		this.props.onRef(null)
	}

	handleClose() {
		this.props.cancel();
		this.setState({ show: false});
	}

	handleShow() {
		this.setState({ health_facilities_id:"",convoke_places_id:"",profile:"", require_convoke_place:false});
		//console.log(this.props.token)
		fetch(Config.default.apiGateway.URL+'access?option=&x', {
		  method: 'GET', // or 'PUT'
		  headers: new Headers({
		  	'Authorization': 'Bearer ' + this.props.token,
		  	'Accept': 'application/json',
		  	'Content-Type': 'application/json;charset=UTF-8'
		  })
		}).then(res => res.ok?res.json():console.log(res))
		.catch(error => console.error('Error:', error))
		.then(response => {
			if(response.health_facilities.length === 1){
				this.setState({
					health_facilities_id: response.health_facilities[0].id,
					health_facilities_name: response.health_facilities[0].name,
					matriz:response.health_facilities[0].principal,
					entity_type:response.health_facilities[0].entity_type
				})

				this.save();
			}else{
				this.setState({
					health_facilities:response.health_facilities, 
					show: true
				});
			}
				
		});
	}

	save(e){
		if(e !== undefined)
			e.preventDefault();

		if(this.isValidForm()){
			sessionStorage.setItem("matriz", this.state.matriz);
			sessionStorage.setItem("entity_type", this.state.entity_type);
			this.props.save(this.state.health_facilities_id, 
				this.state.health_facilities_name,
				this.state.profile,
				this.state.convoke_places_id,
				this.state.facility_sections_id);
		}else{
			swal('¡Error!', 'Campos Incompletos', 'error');
		}
		
	}

	selectFieldHandle = (event) => {
		this.setState({[event.target.name]:event.target.value});

		if(event.target.name === "profile"){
			if(event.target.value === "PERSONAL_BANCO_DE_SANGRE"){
				this.setState({require_convoke_place:true});
			}else{
				this.setState({require_convoke_place:false});
			}
		}

		if(event.target.id !== null){
			var control = document.getElementById(event.target.id);
			if(control.required && control.className.includes('error')){
				control.classList.remove('error');
			}
		}

		if(event.target.name === 'health_facilities_id'){
			var index = this.state.health_facilities.findIndex(obj => obj.id === parseInt(event.target.value));
		
			if(index !== -1){
				this.setState({
					health_facilities_name: this.state.health_facilities[index].name,
					matriz: this.state.health_facilities[index].principal,
					entity_type:this.state.health_facilities[index].entity_type,
				})
			}
				

			this.getArea(event.target.value);


		}
	}

	//Verificar si el formulario es valido
	isValidForm() {
		const ctrls = document.querySelectorAll('select');
	    let isFormValid = true;

	    ctrls.forEach(ctrl => {
	    	if(ctrl.required){
		      	const isInputValid = this.showCtrlError(ctrl.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		  	}
	    });

	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {
	        if(control !== null){
	            control.classList.add('error');
	        }
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
		        	control.classList.remove('error');
		    	}
	    	}
			res = true;
		}

		return res;
	}

	getArea(id){
		fetch(Config.default.apiGateway.URL+'facility_sections?health_facility_id='+id+'&x=donors', {
			method : 'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		})
		.then(res => res.json())
		.then(response => {
			this.setState({
				facility_sections: response
			})
		})
	}

	render(){
		const { t } = this.props;
		return(
			<Modal show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>{t('content.modal_set_info.MAIN')}</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row" align="center">
		 				<div className="col-xs-12 form-group">
		 					<div className="col-xs-4" >
		 						<span >{t('content.modal_set_info.health_facility')}:</span>
		 					</div>
		 					<div className="col-xs-8">
		 						<select className="form-control" value={ this.state.health_facilities_id } 
								onChange={ this.selectFieldHandle.bind() } required
								name="health_facilities_id" id="health_facilities_id">
								<option value="" disabled >Seleccionar...</option>
								{
									this.state.health_facilities.map(function(t) {
										return <option key={t.id}  value={t.id}>{t.name}</option>
									})
								}
								</select>
					        </div>
				        </div>
				    </div>
		        </Modal.Body>
		        <Modal.Footer>
		        	<FlatButton primary={true} label={t('content.generics.buttons.login')} keyboardFocused={true} onClick={this.save}/>
		        	<FlatButton primary={true} label={t('content.generics.buttons.reset')}  onClick={this.handleClose}/>
		        </Modal.Footer>
	      	</Modal>
		);
	}
}

export default translate('translations')(ModalSetInfoSession) 